import { Box } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { Sonho } from "../../types";
import { CUpload, VDUploadRef } from "../inputs";
import Input from "../inputs/Input.component";

interface FormSonhoProps {
  initialValues?: Sonho | null;
  onSubmit: (values: Sonho) => Promise<unknown>;
  loading?: boolean;
}

export interface FormSonhoRef {
  submit: () => Promise<void>;
  getFiles: () => File[] | undefined;
  getInitialFiles: () => string[] | undefined;
  getDeleteFiles: () => string[] | undefined;
}

export const FormSonho = forwardRef<FormSonhoRef, FormSonhoProps>(
  (props, ref) => {
    const { register, handleSubmit, watch, reset } = useForm<Sonho>();
    const uploadRef = useRef<VDUploadRef>(null);

    useEffect(() => {
      if (props.initialValues) {
        reset(props.initialValues);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.initialValues]);

    const onSubmit: SubmitHandler<Sonho> = (values) => {
      props.onSubmit(values);
    };

    // Exposing the submit function via ref
    useImperativeHandle(ref, () => ({
      submit: handleSubmit(onSubmit),
      getFiles: () => uploadRef?.current?.getFiles(),
      getInitialFiles: () => uploadRef?.current?.getInitialFiles(),
      getDeleteFiles: () => uploadRef?.current?.getDeleteFiles(),
    }));

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <Input label="Titulo" {...register("title")} loading={props.loading} />
        <Input label="Local" {...register("local")} loading={props.loading} />
        <CUpload ref={uploadRef} defaultValue={watch("imagesUrl")} />
      </Box>
    );
  }
);
